import React from "react";
import PreparingOverlay from "./PreparingOverlay";

export const corporateDashboardPageClassName =
  "flex min-h-screen w-full items-center justify-center bg-[#faf7f2] px-4 py-12 font-lato";

export const corporateDashboardPanelClassName =
  "flex min-h-[min(520px,calc(100vh-6rem))] w-full max-w-lg flex-col rounded-xl border border-[#ddd8d1] bg-[#f2efea] px-6 py-8 shadow-sm";

export const CorporateDashboardPage = ({ children }) => (
  <div className={corporateDashboardPageClassName}>{children}</div>
);

const titleFromMessage = (message) => message.replace(/…$/, "").trim();

/**
 * Full-screen preparing overlay (same loader as Quick Prints preview/download).
 * @param {{ message?: string, subtitle?: string }} props
 */
const CorporateDashboardLoading = ({
  message = "Loading your corporate dashboard…",
  subtitle = "This may take a moment…",
}) => (
  <PreparingOverlay title={titleFromMessage(message)} subtitle={subtitle} />
);

/** Generic full-screen loader (same design as Quick Prints / corporate flows). */
export const AppLoadingOverlay = ({ title = "Loading..." } = {}) => (
  <PreparingOverlay title={title} subtitle="" />
);

export default CorporateDashboardLoading;
